import { RouteConfig } from '../types';
import * as Components from '../lazyComponents';

export const promotoraRoutes: RouteConfig[] = [
  {
    path: '/promotora/dashboard',
    element: <Components.PromotoraDashboardPage />,
    roles: ['PROJECT_DEVELOPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/promotora/proyectos',
    element: <Components.PromotoraProjectsPage />,
    roles: ['PROJECT_DEVELOPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/promotora/unidades',
    element: <Components.PromotoraUnitsPage />,
    roles: ['PROJECT_DEVELOPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/promotora/leads',
    element: <Components.PromotoraLeadsPage />,
    roles: ['PROJECT_DEVELOPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/promotora/agencias',
    element: <Components.PromotoraAgenciesPage />,
    roles: ['PROJECT_DEVELOPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/promotora/facturacion',
    element: <Components.PromotoraBillingPage />,
    roles: ['PROJECT_DEVELOPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  // Task #666 — Mi Suscripción (tenant-self billing dashboard)
  {
    path: '/promotora/mi-suscripcion',
    element: <Components.MySubscriptionPage />,
    roles: ['PROJECT_DEVELOPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/promotora/reportes',
    element: <Components.PromotoraReportsPage />,
    roles: ['PROJECT_DEVELOPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/promotora/configuracion',
    element: <Components.PromotoraSettingsPage />,
    roles: ['PROJECT_DEVELOPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  // GH#2250 — «cambiar plan» y «agregar addon» de Mi suscripción, con rutas de este rol.
  // Antes los dos botones mandaban a /agencia/... (sólo AGENCY_ADMIN) y la promotora y el
  // Combo caían en «no autorizado».
  {
    path: '/promotora/configuracion/planes',
    element: <Components.PromotoraPlansPage />,
    roles: ['PROJECT_DEVELOPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/promotora/configuracion/addons',
    element: <Components.AddonsStorePage />,
    roles: ['PROJECT_DEVELOPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  // Formularios de creación
  {
    path: '/promotora/proyectos/nuevo',
    element: <Components.PromotoraNewProjectPage />,
    roles: ['PROJECT_DEVELOPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/promotora/unidades/nueva',
    element: <Components.PromotoraNewUnitPage />,
    roles: ['PROJECT_DEVELOPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/promotora/leads/nuevo',
    element: <Components.PromotoraNewLeadPage />,
    roles: ['PROJECT_DEVELOPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/promotora/agencias/nueva',
    element: <Components.PromotoraNewAgencyPage />,
    roles: ['PROJECT_DEVELOPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/promotora/facturacion/nueva',
    element: <Components.PromotoraNewInvoicePage />,
    roles: ['PROJECT_DEVELOPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  // Formularios de edición
  {
    path: '/promotora/proyectos/:id/editar',
    element: <Components.PromotoraEditProjectPage />,
    roles: ['PROJECT_DEVELOPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
];
